"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var __1 = require("../../");
var context_1 = require("../../../context");
var SectionHeading_1 = __importDefault(require("../../SectionHeading"));
var MedicalDetailsProfile = function (_a) {
    var client = _a.client;
    var trans = context_1.useSemantics().trans;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SectionHeading_1.default, { className: "pb-8", heading: trans('optiiva::headings.medical'), subHeading: trans('optiiva::headings.personal') }),
        react_1.default.createElement(__1.DataRow, { horizontal: true, label: trans('optiiva::labels.nhs-number'), value: client.nhs_number || trans('optiiva::misc.empty-line') }),
        react_1.default.createElement(__1.DataRow, { horizontal: true, dropBorder: true, label: trans('optiiva::labels.gp'), value: client.gp_name || trans('optiiva::misc.empty-line') })));
};
exports.default = MedicalDetailsProfile;
//# sourceMappingURL=MedicalDetailsProfile.js.map